import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import 'react-datepicker/dist/react-datepicker.css';

import CargomaticModal from 'components/v2/modal';
import AppointmentPicker from 'components/ui/tailwind/AppointmentPicker';
import { withTranslation } from 'react-i18next';

const getInitialState = (props) => {
  const { stop } = props;
  const { window_start, window_end } = stop;

  const timezone = props.selected_timezone;
  const momentStartDate = window_start
    ? moment.tz(window_start, timezone)
    : null;
  const momentEndDate = window_end ? moment.tz(window_end, timezone) : null;

  const start =
    momentStartDate && momentStartDate.isValid() ? momentStartDate : null;
  const end = momentEndDate && momentEndDate.isValid() ? momentEndDate : null;

  return {
    timezone,
    start,
    end,
    hideConfirm: true,
    errors: [],
    isValid: true,
  };
};

class StopAppointmentWindowModal extends Component {
  constructor(props) {
    super(props);
    this.state = getInitialState(props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props !== newProps) {
      this.setState(getInitialState(newProps));
    }
  }

  getBody = () => {
    return (
      <div className="flex justify-center">
        <AppointmentPicker
          start={this.state.start}
          end={this.state.end}
          confirmed={false}
          selected_timezone={this.state.timezone}
          storeTimeZoneChange={this.storeTimeZoneChange}
          onStartChange={this.props.onStartChange}
          onEndChange={this.props.onEndChange}
          onToggleConfirmed={() => {}}
          hideConfirm={this.state.hideConfirm}
        />
      </div>
    );
  };

  getFooter = () => {
    const { t } = this.props;
    return (
      <button className="button button-green" onClick={this.props.onClose}>
        {t('DONE')}
      </button>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <CargomaticModal
        title={t('STOP_APPOINTMENT')}
        style={{ top: '30%' }}
        show={this.props.show}
        onHide={this.props.onClose}
        body={this.getBody()}
        footer={this.getFooter()}
      />
    );
  }
}

StopAppointmentWindowModal.propTypes = {
  // stop: PropTypes.object.isRequired,
  // selected_timezone: PropTypes.string.isRequired,
  onStartChange: PropTypes.func.isRequired,
  onEndChange: PropTypes.func.isRequired,
};
export default withTranslation()(StopAppointmentWindowModal)
